module.exports = __webpack_public_path__ + "img/doggie_for_bookcharity.34138e24.gif";